__turbopack_context__.v({
  "action": "LatestContestAnnouncement-module-scss-module__I8NQ2W__action",
  "body": "LatestContestAnnouncement-module-scss-module__I8NQ2W__body",
  "close": "LatestContestAnnouncement-module-scss-module__I8NQ2W__close",
  "container": "LatestContestAnnouncement-module-scss-module__I8NQ2W__container",
  "content": "LatestContestAnnouncement-module-scss-module__I8NQ2W__content",
  "details": "LatestContestAnnouncement-module-scss-module__I8NQ2W__details",
  "title": "LatestContestAnnouncement-module-scss-module__I8NQ2W__title",
});
